import { PropsWithClassname } from '@/app/types';

export const DownloadIcon = ({ className }: PropsWithClassname) => {
  return (
    <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none">
      <g id="Icon/Download">
        <path
          id="Icon (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.0013 1.66663C10.4615 1.66663 10.8346 2.03972 10.8346 2.49996V10.4881L13.5787 7.74404C13.9042 7.4186 14.4318 7.4186 14.7572 7.74404C15.0827 8.06947 15.0827 8.59711 14.7572 8.92255L10.5906 13.0892C10.2651 13.4147 9.73748 13.4147 9.41205 13.0892L5.24538 8.92255C4.91994 8.59711 4.91994 8.06947 5.24538 7.74404C5.57082 7.4186 6.09845 7.4186 6.42389 7.74404L9.16797 10.4881V2.49996C9.16797 2.03972 9.54106 1.66663 10.0013 1.66663ZM2.5013 11.6666C2.96154 11.6666 3.33464 12.0397 3.33464 12.5V15.8333C3.33464 16.0543 3.42243 16.2663 3.57871 16.4225C3.73499 16.5788 3.94696 16.6666 4.16797 16.6666H15.8346C16.0556 16.6666 16.2676 16.5788 16.4239 16.4225C16.5802 16.2663 16.668 16.0543 16.668 15.8333V12.5C16.668 12.0397 17.0411 11.6666 17.5013 11.6666C17.9615 11.6666 18.3346 12.0397 18.3346 12.5V15.8333C18.3346 16.4963 18.0712 17.1322 17.6024 17.6011C17.1336 18.0699 16.4977 18.3333 15.8346 18.3333H4.16797C3.50493 18.3333 2.86904 18.0699 2.4002 17.6011C1.93136 17.1322 1.66797 16.4963 1.66797 15.8333V12.5C1.66797 12.0397 2.04106 11.6666 2.5013 11.6666Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
